<div class="card card-nc esign_box ">
  <div class="container">
    <div class="col-12">
      <div style="width: 80%; margin: 0 auto;">
        <app-progress-bar
          [whichStep]="2"
          [sectionsArray]="tabs"
        ></app-progress-bar>
      </div>
    </div>
  </div>
  <br />
<app-privacy-policy></app-privacy-policy>

  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <br />
            <div class="checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="agree" value="true" />
                I have read and agree to the Privacy Policy
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button
        id="enroll_button"
        name="terms_button"
        [disabled]="!agree"
        type="button"
        class="btn btn-block pull-right"
        (click)="next()"
      >
        I Agree
      </button>
    </div>
  </div>
</div>
